"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscriber = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _isFunction = require("./util/isFunction");

var _Subscription2 = require("./Subscription");

var _Observer = require("./Observer");

var _rxSubscriber = require("./symbol/rxSubscriber");

/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber =
/*#__PURE__*/
function (_Subscription) {
  (0, _inherits2.default)(Subscriber, _Subscription);

  /**
   * @param {Observer|function(value: T): void} [destinationOrNext] A partially
   * defined Observer or a `next` callback function.
   * @param {function(e: ?any): void} [error] The `error` callback of an
   * Observer.
   * @param {function(): void} [complete] The `complete` callback of an
   * Observer.
   */
  function Subscriber(destinationOrNext, error, complete) {
    var _this;

    (0, _classCallCheck2.default)(this, Subscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Subscriber).call(this));
    _this.syncErrorValue = null;
    _this.syncErrorThrown = false;
    _this.syncErrorThrowable = false;
    _this.isStopped = false;

    switch (arguments.length) {
      case 0:
        _this.destination = _Observer.empty;
        break;

      case 1:
        if (!destinationOrNext) {
          _this.destination = _Observer.empty;
          break;
        }

        if ((0, _typeof2.default)(destinationOrNext) === 'object') {
          if (destinationOrNext instanceof Subscriber) {
            _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
            _this.destination = destinationOrNext;

            _this.destination.add((0, _assertThisInitialized2.default)(_this));
          } else {
            _this.syncErrorThrowable = true;
            _this.destination = new SafeSubscriber((0, _assertThisInitialized2.default)(_this), destinationOrNext);
          }

          break;
        }

      default:
        _this.syncErrorThrowable = true;
        _this.destination = new SafeSubscriber((0, _assertThisInitialized2.default)(_this), destinationOrNext, error, complete);
        break;
    }

    return _this;
  }

  (0, _createClass2.default)(Subscriber, [{
    key: _rxSubscriber.rxSubscriber,
    value: function value() {
      return this;
    }
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */

  }, {
    key: "next",

    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    value: function next(value) {
      if (!this.isStopped) {
        this._next(value);
      }
    }
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */

  }, {
    key: "error",
    value: function error(err) {
      if (!this.isStopped) {
        this.isStopped = true;

        this._error(err);
      }
    }
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */

  }, {
    key: "complete",
    value: function complete() {
      if (!this.isStopped) {
        this.isStopped = true;

        this._complete();
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.closed) {
        return;
      }

      this.isStopped = true;
      (0, _get2.default)((0, _getPrototypeOf2.default)(Subscriber.prototype), "unsubscribe", this).call(this);
    }
  }, {
    key: "_next",
    value: function _next(value) {
      this.destination.next(value);
    }
  }, {
    key: "_error",
    value: function _error(err) {
      this.destination.error(err);
      this.unsubscribe();
    }
  }, {
    key: "_complete",
    value: function _complete() {
      this.destination.complete();
      this.unsubscribe();
    }
  }, {
    key: "_unsubscribeAndRecycle",
    value: function _unsubscribeAndRecycle() {
      var _parent = this._parent,
          _parents = this._parents;
      this._parent = null;
      this._parents = null;
      this.unsubscribe();
      this.closed = false;
      this.isStopped = false;
      this._parent = _parent;
      this._parents = _parents;
      return this;
    }
  }], [{
    key: "create",
    value: function create(next, error, complete) {
      var subscriber = new Subscriber(next, error, complete);
      subscriber.syncErrorThrowable = false;
      return subscriber;
    }
  }]);
  return Subscriber;
}(_Subscription2.Subscription);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


exports.Subscriber = Subscriber;

var SafeSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(SafeSubscriber, _Subscriber);

  function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
    var _this2;

    (0, _classCallCheck2.default)(this, SafeSubscriber);
    _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SafeSubscriber).call(this));
    _this2._parentSubscriber = _parentSubscriber;
    var next;
    var context = (0, _assertThisInitialized2.default)(_this2);

    if ((0, _isFunction.isFunction)(observerOrNext)) {
      next = observerOrNext;
    } else if (observerOrNext) {
      next = observerOrNext.next;
      error = observerOrNext.error;
      complete = observerOrNext.complete;

      if (observerOrNext !== _Observer.empty) {
        context = Object.create(observerOrNext);

        if ((0, _isFunction.isFunction)(context.unsubscribe)) {
          _this2.add(context.unsubscribe.bind(context));
        }

        context.unsubscribe = _this2.unsubscribe.bind((0, _assertThisInitialized2.default)(_this2));
      }
    }

    _this2._context = context;
    _this2._next = next;
    _this2._error = error;
    _this2._complete = complete;
    return _this2;
  }

  (0, _createClass2.default)(SafeSubscriber, [{
    key: "next",
    value: function next(value) {
      if (!this.isStopped && this._next) {
        var _parentSubscriber = this._parentSubscriber;

        if (!_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(this._next, value);
        } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
          this.unsubscribe();
        }
      }
    }
  }, {
    key: "error",
    value: function error(err) {
      if (!this.isStopped) {
        var _parentSubscriber = this._parentSubscriber;

        if (this._error) {
          if (!_parentSubscriber.syncErrorThrowable) {
            this.__tryOrUnsub(this._error, err);

            this.unsubscribe();
          } else {
            this.__tryOrSetError(_parentSubscriber, this._error, err);

            this.unsubscribe();
          }
        } else if (!_parentSubscriber.syncErrorThrowable) {
          this.unsubscribe();
          throw err;
        } else {
          _parentSubscriber.syncErrorValue = err;
          _parentSubscriber.syncErrorThrown = true;
          this.unsubscribe();
        }
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      var _this3 = this;

      if (!this.isStopped) {
        var _parentSubscriber = this._parentSubscriber;

        if (this._complete) {
          var wrappedComplete = function wrappedComplete() {
            return _this3._complete.call(_this3._context);
          };

          if (!_parentSubscriber.syncErrorThrowable) {
            this.__tryOrUnsub(wrappedComplete);

            this.unsubscribe();
          } else {
            this.__tryOrSetError(_parentSubscriber, wrappedComplete);

            this.unsubscribe();
          }
        } else {
          this.unsubscribe();
        }
      }
    }
  }, {
    key: "__tryOrUnsub",
    value: function __tryOrUnsub(fn, value) {
      try {
        fn.call(this._context, value);
      } catch (err) {
        this.unsubscribe();
        throw err;
      }
    }
  }, {
    key: "__tryOrSetError",
    value: function __tryOrSetError(parent, fn, value) {
      try {
        fn.call(this._context, value);
      } catch (err) {
        parent.syncErrorValue = err;
        parent.syncErrorThrown = true;
        return true;
      }

      return false;
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe() {
      var _parentSubscriber = this._parentSubscriber;
      this._context = null;
      this._parentSubscriber = null;

      _parentSubscriber.unsubscribe();
    }
  }]);
  return SafeSubscriber;
}(Subscriber);